import { withSvgIcon } from './withSvgIcon';

export const SubstackIcon = withSvgIcon(
  <path
    clipRule="evenodd"
    d="M5.42969 4.2356H18.5683V6.07746H5.42969V4.2356ZM5.42969 10.954H18.5683V19.2356L11.9976 15.5503L5.42969 19.2356V10.954ZM5.42969 7.59476H18.5683V9.43662H5.42969V7.59476Z"
    fill="currentColor"
    fillRule="evenodd"
  />,
  { viewBox: '0 0 24 24' },
);
